(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tj-install-guide"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__tjInstallVideoBound) return;
  window.__tjInstallVideoBound = true;

  function parseYouTubeId(value) {
    if (!value) return '';
    var str = String(value).trim();
    var match = str.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/))([A-Za-z0-9_-]{6,})/);
    if (match) return match[1];
    if (/^[A-Za-z0-9_-]{11}$/.test(str)) return str;
    return '';
  }

  function closeModal() {
    var modal = document.getElementById('TjYoutubeModal');
    if (!modal) return;
    modal.classList.remove('is-open');
    var frame = modal.querySelector('[data-tj-video-frame]');
    if (frame) frame.innerHTML = '';
    document.body.style.removeProperty('overflow');
  }

  function openModal(ytId) {
    var modal = document.getElementById('TjYoutubeModal');
    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'TjYoutubeModal';
      modal.className = 'tj-video-modal';
      modal.innerHTML =
        '<div class="tj-video-modal__backdrop" data-tj-video-close></div>' +
        '<div class="tj-video-modal__inner" role="dialog" aria-modal="true" aria-label="Installation video">' +
          '<button type="button" class="tj-video-modal__close" data-tj-video-close aria-label="Close">×</button>' +
          '<div class="tj-video-modal__frame" data-tj-video-frame></div>' +
        '</div>';
      document.body.appendChild(modal);
      modal.addEventListener('click', function (event) {
        if (event.target === modal || event.target.closest('[data-tj-video-close]')) closeModal();
      });
    }

    var frame = modal.querySelector('[data-tj-video-frame]');
    frame.innerHTML =
      '<iframe src="https://www.youtube.com/embed/' + encodeURIComponent(ytId) +
      '?autoplay=1&rel=0&modestbranding=1" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen title="Installation video"></iframe>';
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-tj-video-open]');
    if (!trigger) return;
    var ytId = parseYouTubeId(trigger.getAttribute('data-tj-yt')) || parseYouTubeId(trigger.getAttribute('data-tj-yt-url'));
    if (!ytId) return;
    event.preventDefault();
    openModal(ytId);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeModal();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tj-voc-stories"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__tjInstallVideoBound) return;
  window.__tjInstallVideoBound = true;

  function parseYouTubeId(value) {
    if (!value) return '';
    var str = String(value).trim();
    var match = str.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/))([A-Za-z0-9_-]{6,})/);
    if (match) return match[1];
    if (/^[A-Za-z0-9_-]{11}$/.test(str)) return str;
    return '';
  }

  function parseYouTubeStart(value) {
    if (!value) return 0;
    var str = String(value);
    var match = str.match(/[?&#](?:t|start)=([0-9hms]+)/i);
    if (!match) return 0;
    var token = match[1];
    if (/^\d+$/.test(token)) return parseInt(token, 10);
    var hours = token.match(/(\d+)h/);
    var mins = token.match(/(\d+)m/);
    var secs = token.match(/(\d+)s/);
    return (hours ? parseInt(hours[1], 10) * 3600 : 0)
      + (mins ? parseInt(mins[1], 10) * 60 : 0)
      + (secs ? parseInt(secs[1], 10) : 0);
  }

  function closeModal() {
    var modal = document.getElementById('TjYoutubeModal');
    if (!modal) return;
    modal.classList.remove('is-open');
    var frame = modal.querySelector('[data-tj-video-frame]');
    if (frame) frame.innerHTML = '';
    document.body.style.removeProperty('overflow');
  }

  function openModal(ytId, startSeconds) {
    var modal = document.getElementById('TjYoutubeModal');
    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'TjYoutubeModal';
      modal.className = 'tj-video-modal';
      modal.innerHTML =
        '<div class="tj-video-modal__backdrop" data-tj-video-close></div>' +
        '<div class="tj-video-modal__inner" role="dialog" aria-modal="true" aria-label="Installation video">' +
          '<button type="button" class="tj-video-modal__close" data-tj-video-close aria-label="Close">×</button>' +
          '<div class="tj-video-modal__frame" data-tj-video-frame></div>' +
        '</div>';
      document.body.appendChild(modal);
      modal.addEventListener('click', function (event) {
        if (event.target === modal || event.target.closest('[data-tj-video-close]')) closeModal();
      });
    }

    var startQuery = startSeconds > 0 ? '&start=' + startSeconds : '';
    var frame = modal.querySelector('[data-tj-video-frame]');
    frame.innerHTML =
      '<iframe src="https://www.youtube.com/embed/' + encodeURIComponent(ytId) +
      '?autoplay=1&rel=0&modestbranding=1' + startQuery + '" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen title="Installation video"></iframe>';
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-tj-video-open]');
    if (!trigger) return;
    var ytUrl = trigger.getAttribute('data-tj-yt-url') || '';
    var ytId = parseYouTubeId(trigger.getAttribute('data-tj-yt')) || parseYouTubeId(ytUrl);
    if (!ytId) return;
    event.preventDefault();
    var startFromSetting = parseInt(trigger.getAttribute('data-tj-yt-start') || '0', 10) || 0;
    openModal(ytId, startFromSetting || parseYouTubeStart(ytUrl));
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeModal();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
